import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Person } from './person'

export class PersonsRepository extends BaseRepository<Person> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'persons', token, cache)
    }

    async Birthdays(from: Date, to: Date) {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/persons/birthdays?from=' + from + '&to=' + to + '&token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async reactivate(personId: string) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.eventApiUrl + '/persons/' + personId + '/reactivate?token=' + this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getRecents(recents: number) {
        const url = this.config.eventApiUrl + '/persons/recents?recents=' + recents + '&token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async LoginByLink(personId: string) {
        const { json, statusCode, message } = await this.request.post(this.config.eventApiUrl + '/persons/login/link?token=' + this.resolvedToken, {
            personId,
        })
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async search(query: string, limit: number = 100) {
        const { json, statusCode, message } = await this.request.get(
            this.config.eventApiUrl + '/persons/search?query=' + query + '&limit=' + limit + '&token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
